const cnfsdSpeedingFinesCalc = (function () {
    let weeklyIncome = 0,
        speedLimit = 0,
        speedTravelling = 0,
        percentOfIncome = 0,
        band = "",
        fine = 0,
        points = "",
        percent = "",
        container = null;

    function init() {
        container = document.getElementById('speeding-fines-calculator');
        container.querySelectorAll('input[type="number"]').forEach(input => input.addEventListener('keyup', e => onInputChange(e)));
        container.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', e => onInputChange(e)));
        container.querySelector('.btn--calculate').addEventListener('click', e => formSubmit(e));
        container.querySelector('.btn--reset').addEventListener('click', reset);
    };

    function onInputChange(e) {
        const input = e.target;
        const value = input.value;
        let el_parent;

        switch (input.id) {
            case "q1-income":
                el_parent = container.querySelector('#q1');
                weeklyIncome = value / 52;
                break;

            case "q3-speed":
                el_parent = container.querySelector('#q3');
                speedTravelling = +value;
                break;

            default:
                el_parent = container.querySelector('#q2');
                speedLimit = value;
        }

        const validationMsg = el_parent.querySelector('.field-validation-error');
        validationMsg !== null && validationMsg.classList.add("display-none");
        input.parentNode.classList.contains('error') && input.parentNode.classList.remove('error');
    };

    function validateInputs() {
        let valid = true;
        const el_q1 = container.querySelector('#q1-income');
        const el_q2_checked = container.querySelector('input[type="radio"]:checked');
        const el_q3 = container.querySelector('#q3-speed'); // Q1

        if (el_q1.value === "" || el_q1.value < 1) {
            valid = false;
            const errorField = container.querySelector('#q1 .field-validation-error');
            errorField !== null && errorField.classList.remove("display-none");
            errorField.nextElementSibling.classList.add("error");
        } // Q2


        if (el_q2_checked === undefined || el_q2_checked === null) {
            valid = false;
            const errorField = container.querySelector('#q2 .field-validation-error');
            errorField !== null && errorField.classList.remove("display-none");
        } // Q3


        if (el_q3.value === "" || el_q3.value < 1) {
            valid = false;
            const errorField = container.querySelector('#q3 .field-validation-error');
            errorField !== null && errorField.classList.remove("display-none");
            errorField.nextElementSibling.classList.add("error");
        }

        return valid;
    };

    function updateProgressTracker(direction) {
        const bar1 = container.querySelector('#progress-1');
        const bar2 = container.querySelector('#progress-2');
        const stepNum = container.querySelector('#progress-tracker-stepNum');

        if (direction === "forward") {
            bar1.classList.remove('active');
            bar1.classList.add('completed');
            bar2.classList.add('active');
            stepNum.textContent = "2";
        } else {
            bar1.classList.add('active');
            bar1.classList.remove('completed');
            bar2.classList.remove('active');
            stepNum.textContent = "1";
        }
    };

    function formSubmit(e) {
        e.preventDefault();
        if (!validateInputs()) return;
        updateProgressTracker('forward');
        let speedsArr;

        switch (speedLimit) {
            case "20":
                speedsArr = [21, 30, 31, 40, 41];
                break;

            case "30":
                speedsArr = [31, 40, 41, 50, 51];
                break;

            case "40":
                speedsArr = [41, 55, 56, 65, 66];
                break;

            case "50":
                speedsArr = [51, 65, 66, 75, 76];
                break;

            case "60":
                speedsArr = [61, 80, 81, 90, 91];
                break;

            case "70":
                speedsArr = [71, 90, 91, 100, 101];
                break;
        }

        setBand(speedsArr);
        calculateFine();
        setUI();
    };

    function setBand(limits) {
        if (speedTravelling >= limits[0] && speedTravelling <= limits[1]) {
            band = "a";
            points = "3";
            percent = "75%";
        } else if (speedTravelling >= limits[2] && speedTravelling <= limits[3]) {
            band = "b";
            points = "4-6";
            percent = "125%";
        } else if (speedTravelling >= limits[4]) {
            band = "c";
            points = "6";
            percent = "175%";
        } else {
            band = "d";
            points = "";
            percent = "";
        }
    };

    function calculateFine() {
        if (band === "a") {
            percentOfIncome = 0.75;
        } else if (band === "b") {
            percentOfIncome = 1.25;
        } else if (band === "c") {
            percentOfIncome = 1.75;
        }

        fine = (percentOfIncome * weeklyIncome).toFixed(2);
        if (fine >= 1000) fine = 1000;
        if (band === "d") fine = 0;
    };

    function setUI() {
        const resultsContainer = container.querySelector('.results--container');
        resultsContainer.textContent = '';
        container.querySelector('.questions--container').classList.add('display-none');
        resultsContainer.classList.remove('display-none');
        container.querySelector('.footer-text').classList.remove('display-none');
        container.querySelector('.btn--reset').classList.remove('display-none');

        if (band === "d") {
            const notSpeedingTemplate = container.querySelector('#not-speeding-results').content;
            const notSpeedingNode = notSpeedingTemplate.cloneNode(true);
            resultsContainer.appendChild(notSpeedingNode);
        } else {
            const speedingTemplate = container.querySelector('#speeding-results').content;
            const speedingNode = speedingTemplate.cloneNode(true);
            speedingNode.querySelector('#fine-amount').textContent = "\xA3".concat(fine);
            speedingNode.querySelector('#percentage').textContent = percent;
            speedingNode.querySelector('#points').textContent = points;
            resultsContainer.appendChild(speedingNode);
        }

        container.querySelector('.progress-tracker h2').scrollIntoView({
            behavior: "smooth"
        });
    };

    function reset() {
        updateProgressTracker('backward');
        container.querySelector('.questions--container').classList.remove('display-none');
        container.querySelector('.results--container').classList.add('display-none');
        container.querySelector('.footer-text').classList.add('display-none');
        container.querySelector('.btn--reset').classList.add('display-none');
        container.querySelector('input[type="radio"]:checked').checked = false;
        container.querySelector('#q1-income').value = "";
        container.querySelector('#q3-speed').value = "";
    };

    return {
        init: init
    }
})();

document.addEventListener('DOMContentLoaded', () => {
    cnfsdSpeedingFinesCalc.init();
});